import { render, staticRenderFns } from "./JewelryCertificatePrint.vue?vue&type=template&id=3dc3c94a&scoped=true"
import script from "./JewelryCertificatePrint.vue?vue&type=script&lang=js"
export * from "./JewelryCertificatePrint.vue?vue&type=script&lang=js"
import style0 from "./JewelryCertificatePrint.vue?vue&type=style&index=0&id=3dc3c94a&prod&scoped=true&lang=css"
import style1 from "./JewelryCertificatePrint.vue?vue&type=style&index=1&id=3dc3c94a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc3c94a",
  null
  
)

export default component.exports